// extracted by mini-css-extract-plugin
export default {"applyButton":"Message_applyButton__BwgCS","responsiveVideo":"Message_responsiveVideo__M5Lj2"};